interface Location {
    locationId: string;
    presentationName: string;
    urlState: string;
    StationName: string;
    countryCde: string;
    urlName: string;
    CALL: string;
    stateCode: string;
    stateName: string;
    cityName: string;
    Lat: string;
    Lng: string;
    Elev: string;
    usaf: string;
    wban: string;
    urlCountry: string;
}
export const useLocations = async (urlName: string, urlState: string) => {
    const config = useRuntimeConfig();
    const { data, error} = await useFetch<Location[]>(config.public.LOCATIONS_DATA_URL);

    /* bail if nothing returned */
    if (error.value !== null || data.value === null) {
        return {
            loaded: ref(false),
            error: error.value
        }
    }

    /* filter data */
    const placeData = data.value.filter((place: Location) => {

        if (urlName !== undefined && urlState !== undefined) {
            if (place.urlName === urlName && place.urlState === urlState) {
                return place;
            }
        } else if (urlState !== undefined) {
            if (place.urlState === urlState) {
                return place
            }
        }
    });

    return {
        loaded: ref(true),
        location: placeData[0],
        error: error.value
    }
}